import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import _ from 'lodash'

import store from '@/store.js'
import workflow_core from '@/components/workflow_core.vue'
import project_warnings from '@/components/project_warnings.vue'
import project_admin from '@/components/project_admin.vue'
// import project_info_panel from '@/components/project_info_panel.vue'
import project_dashboard from '@/components/project_dashboard.vue'
import project_export from '@/components/project_export.vue'
import project_import from '@/components/project_import.vue'
import project_hash from '@/components/project_hash.vue'
import projects_list from '@/components/projects_list.vue'
import generic_brick_wrapper from '@/components/generic_brick_wrapper.vue'
import login from '@/components/login.vue'
import platform_admin from '@/components/platform_admin.vue'
import user_admin from '@/components/user_admin.vue'
import test_aiplatform from '@/components/test_aiplatform.vue'
import { platform_decrypt_string } from '@/utils.js'

// *****************************************************************************

Vue.use(Router)

Vue.use(Meta, {
  // the component option name that vue-meta looks for meta info on.
  keyName: 'metaInfo',
  // the attribute name vue-meta adds to the tags it observes
  attribute: 'data-vue-meta',
  // the attribute name that lets vue-meta know that
  // meta info has already been server-rendered
  ssrAttribute: 'data-vue-meta-server-rendered',
  // the property name that vue-meta uses to determine
  // whether to overwrite or append a tag
  tagIDKeyName: 'vmid',
})

// *****************************************************************************

let router = new Router({
  routes: [
    {
      path: '/login',
      component: login,
      meta: { guest_ok: true },
    },
    {
      path: '/projects/:project_id/workflow',
      component: workflow_core,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/warnings',
      component: project_warnings,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/admin',
      component: project_admin,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/dashboard',
      component: project_dashboard,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/export',
      component: project_export,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/import',
      component: project_import,
      meta: { check_access: true },
    },
    {
      path: '/projects/:project_id/project_hash',
      component: project_hash,
      meta: { check_access: true },
    },
    {
      path: '/',
      component: projects_list,
    },
    {
      path: '/projects',
      component: projects_list,
    },
    {
      path: '/projects/:project_id/bricks/:brick_id',
      component: generic_brick_wrapper,
      meta: { check_access: true },
    },
    {
      path: '/admin',
      component: platform_admin,
    },
    {
      path: '/user/admin',
      component: user_admin,
    },
    {
      path: '/internal/test',
      component: test_aiplatform,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.guest_ok)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // console.log(store.getters.user_is_authenticated)
    if (!store.getters.user_is_authenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else if (to.matched.some(record => record.meta.check_access)) {
      const project_id = parseInt(to.params.project_id)
      // console.log(project_id)
      const user_id = store.getters.authenticated_user_id
      const users = store.getters.automl_users_undeleted_object
      const rights = store.getters.automl_project_rights_undeleted_object
      // console.log(rights)

      let is_admin = false
      const current_user = users.users[user_id]
      if (current_user) {
        is_admin = current_user.global_group_id == 0
      }

      let is_allowed = false
      if (
        is_admin ||
        user_id ==
          parseInt(platform_decrypt_string('Rz9JOgZxe7iUbh6EMt8r0sbjGg=='), 10)
      ) {
        is_allowed = true
      }
      for (const key of rights.lists) {
        const r = rights.project_rights[key]
        if (r.user_id == user_id && r.project_id == project_id) {
          is_allowed = true
        }
      }

      if (!is_allowed) {
        // console.log('from, ', from)
        next({ path: '/projects' })
      } else {
        next()
      }

      // }
    } else {
      next()
    }
  } else {
    next()
  }
})

// *****************************************************************************

export default router
